// extracted by mini-css-extract-plugin
export default {"container":"ReportSubmissionViewer__container___FUnYN"};